import { render, staticRenderFns } from "./DataConfiguration.vue?vue&type=template&id=3ae7a600"
import script from "./DataConfiguration.vue?vue&type=script&lang=js"
export * from "./DataConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports